// extracted by mini-css-extract-plugin
export default {"container":"Products_container__R+iIn","products":"Products_products__E1UPE","menu":"Products_menu__ZIez9","list":"Products_list__e+oKk","product":"Products_product__Xza0U"};